import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useFraudConfirmationQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    (cardId: string) => api.post(API_URL.CARDS_FRAUD_CONFIRMATION_BY_CARD_ID(cardId)),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.ACTIVITY_LOGS],
        });
      },
    }
  );

  return {
    confirmFraud: mutateAsync,
    isConfirmFraudLoading: isLoading,
  };
};

export default useFraudConfirmationQuery;
